module.exports = __webpack_public_path__ + "img/userLogo20.525bdf59.jpg";